// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df4433a9","455":"c312381b","977":"3b9fcced"}[chunkId] + ".chunk.js";
};